import {
    ExtractSuspenseQueryOptions,
    useSuspenseRequest
} from "@/lib/openapi/hooks";
import { UseMeasurementFetchParams, UseMeasurementResponse } from "@/types/measurement/measurement";

export const useMeasurementSuspenseQuery = <
  Response extends UseMeasurementResponse,
  Transformed = Response
>({
  queryOptions,
  fetchParams,
}: {
  queryOptions?: ExtractSuspenseQueryOptions<Response, Transformed>;
  fetchParams?: UseMeasurementFetchParams;
}) =>
  useSuspenseRequest("serviceMeasurements", "/measurement", {
    method: "get",
    queryOptions,
    fetchParams,
  });
